import Api from "../../Server/Api";
import { UPDATE } from "./types";

const api = new Api();

export const updateSignup = (data = {}) => {
	// return { ...data, type: UPDATE };
	return async (dispatch) => {
		dispatch({ ...data, type: UPDATE, searching: true })
		const res = await api.post({ endpoint: "users/checkuser/", data: { username: data?.username } });
		dispatch({ ...data, type: UPDATE, searching: false, check: res })
	}
};
